export const oimDialogConfig = {
    title: 'NEW SHIPMENT - OCEAN IMPORT',
    formState: 'oimNewShipmentForm',
    resetAction: 'resetFormDataOim',
    setFormDataAction: 'setFormDataOim',
    tableName: 'il_ocean_import',
    sendReducerNames: ['addOimForm', 'addOimHBL', 'addOimContainer', 'addOimRate'],
    keyName: [
        'il_ocean_import_hbl',
        'il_ocean_import_cntr',
        'hbl',
        'il_trade_partner_id_shipper',
        'il_trade_partner_id_consignee',
    ],
    reducerActionsHBL: ['addHBLOim', 'UpdateHBLtitleOim', 'deleteHBLOim', 'updateHBLOim'],
    reducerActionsCNTR: ['addContainerOim', 'updateContainerOim', 'deleteContainerOim'],
    type: 'ocean',

    sections: [
        {
            title: 'SHIPMENT INFO',
            usage: 'NewShipmentDialog',
            size: 3,
            sx: { height: '400px' },
            fields: [
                {
                    key: 'il_team_id',
                    label: 'Team',
                    type: 'AutocompleteFieldTeam',
                    sx: { gap: '15px' },
                },
                {
                    key: 'il_opus_reference_id',
                    label: 'Opus Ref',
                    type: 'InputField',
                    sx: { gap: '15px' },
                },
                {
                    key: 'il_trade_partner_id_client',
                    label: 'Client',
                    type: 'AutocompleteFieldTradePartner',
                    dataType: 'il_trade_partner',
                },
                {
                    key: 'il_trade_partner_id_forwarder',
                    label: 'Forwarder',
                    type: 'AutocompleteFieldTradePartner',
                    dataType: 'il_trade_partner',
                    sx: { gap: '15px' },
                },
                { key: 'mbl', label: 'MBL', type: 'InputField', sx: { gap: '15px' } },
                {
                    key: 'il_opus_vessel_id',
                    label: 'Vessel',
                    type: 'AutocompleteField_String',
                    dataType: 'il_opus_vessel',
                    freeSolo: true,
                    disable: false,
                    sx: { gap: '15px' },
                },
                {
                    key: 'incoterm',
                    label: 'Incoterm',
                    type: 'AutocompleteField_Single',
                    options: 'incotermList',
                    sx: { gap: '15px' },
                },
            ],
        },
        {
            title: 'DATE/PLACE INFO',
            usage: 'NewShipmentDialog',
            sx: { height: '400px' },
            size: 3,
            fields: [
                {
                    key: 'etd',
                    label: 'ETD',
                    type: 'DateField',
                },
                {
                    key: 'eta',
                    label: 'ETA',
                    type: 'DateField',
                },
                {
                    key: 'feta',
                    label: 'F.ETA',
                    type: 'DateField',
                },
                {
                    key: 'il_location_id_pol',
                    label: 'POL',
                    type: 'AutocompleteField_CodeName',
                    dataType: 'il_location',
                    displayKey: 'name',
                },
                {
                    key: 'il_location_id_pod',
                    label: 'POD',
                    type: 'AutocompleteField_CodeName',
                    dataType: 'il_location',
                    displayKey: 'name',
                },
                {
                    key: 'il_location_id_fpod',
                    label: 'F.POD',
                    type: 'AutocompleteField_CodeName',
                    dataType: 'il_location',
                    displayKey: 'name',
                },
            ],
        },
        {
            title: 'HBL',
            usage: 'NewShipmentCNTR',
            sx: { height: '400px', p: 1 },
            size: 6,
            fields: [{ key: 'hbl', type: 'NewShipmentHBL' }],
            sections: [
                {
                    key: 'il_trade_partner_id_shipper',
                    label: 'Shipper',
                    type: 'AutocompleteFieldTradePartner',
                    dataType: 'il_trade_partner',
                },
                {
                    key: 'il_trade_partner_id_consignee',
                    label: 'Consignee',
                    type: 'AutocompleteFieldTradePartner',
                    dataType: 'il_trade_partner',
                },
                {
                    key: 'reference',
                    label: 'Reference',
                    type: 'InputField',
                    sx: { gap: '15px' },
                },
            ],
        },
    ],
};

export const oexDialogConfig = {
    title: 'NEW SHIPMENT - OCEAN EXPORT',
    formState: 'oexNewShipmentForm',
    resetAction: 'resetFormDataOex',
    setFormDataAction: 'setFormDataOex',
    tableName: 'il_ocean_export',
    sendReducerNames: ['addOexForm', 'addOexHBL', 'addOexContainer', 'addOexRate'],
    keyName: [
        'il_ocean_export_hbl',
        'il_ocean_export_cntr',
        'hbl',
        'il_trade_partner_id_shipper',
        'il_trade_partner_id_consignee',
    ],
    reducerActionsHBL: ['addHBLOex', 'UpdateHBLtitleOex', 'deleteHBLOex', 'updateHBLOex'],
    reducerActionsCNTR: ['addContainerOex', 'updateContainerOex', 'deleteContainerOex'],
    type: 'ocean',
    sections: [
        {
            title: 'SHIPMENT INFO',
            sx: { height: '400px' },
            size: 3,
            fields: [
                {
                    key: 'il_team_id',
                    label: 'Team',
                    type: 'AutocompleteFieldTeam',
                    sx: { gap: '15px' },
                },
                {
                    key: 'il_opus_reference_id',
                    label: 'Opus Ref',
                    type: 'InputField',
                    sx: { gap: '15px' },
                },
                {
                    key: 'il_trade_partner_id_client',
                    label: 'Client',
                    type: 'AutocompleteFieldTradePartner',
                    dataType: 'il_trade_partner',
                },
                {
                    key: 'il_trade_partner_id_forwarder',
                    label: 'Forwarder',
                    type: 'AutocompleteFieldTradePartner',
                    dataType: 'il_trade_partner',
                    sx: { gap: '15px' },
                },
                { key: 'booking_number', label: 'Booking', type: 'InputField', sx: { gap: '15px' } },
                { key: 'mbl', label: 'MBL', type: 'InputField', sx: { gap: '15px' } },
                {
                    key: 'il_opus_vessel_id',
                    label: 'Vessel',
                    type: 'AutocompleteField_String',
                    dataType: 'il_opus_vessel',
                    freeSolo: true,
                    disable: false,
                    sx: { gap: '15px' },
                },
                {
                    key: 'incoterm',
                    label: 'Incoterm',
                    type: 'AutocompleteField_Single',
                    options: 'incotermList',
                    sx: { gap: '15px' },
                },
            ],
        },
        {
            title: 'DATE/PLACE INFO',
            sx: { height: '400px' },
            size: 3,
            fields: [
                {
                    key: 'etd',
                    label: 'ETD',
                    type: 'DateField',
                },
                {
                    key: 'eta',
                    label: 'ETA',
                    type: 'DateField',
                },
                {
                    key: 'feta',
                    label: 'F.ETA',
                    type: 'DateField',
                },
                {
                    key: 'il_location_id_pol',
                    label: 'POL',
                    type: 'AutocompleteField_CodeName',
                    dataType: 'il_location',
                    displayKey: 'name',
                },
                {
                    key: 'il_location_id_pod',
                    label: 'POD',
                    type: 'AutocompleteField_CodeName',
                    dataType: 'il_location',
                    displayKey: 'name',
                },
                {
                    key: 'il_location_id_fpod',
                    label: 'F.POD',
                    type: 'AutocompleteField_CodeName',
                    dataType: 'il_location',
                    displayKey: 'name',
                },
            ],
        },
        {
            title: 'HBL',
            usage: 'NewShipmentCNTR',
            sx: { height: '400px', p: 1 },
            size: 6,
            fields: [{ key: 'hbl', type: 'NewShipmentHBL' }],
            sections: [
                {
                    key: 'il_trade_partner_id_shipper',
                    label: 'Shipper',
                    type: 'AutocompleteFieldTradePartner',
                    dataType: 'il_trade_partner',
                },
                {
                    key: 'il_trade_partner_id_consignee',
                    label: 'Consignee',
                    type: 'AutocompleteFieldTradePartner',
                    dataType: 'il_trade_partner',
                },
                {
                    key: 'reference',
                    label: 'Reference',
                    type: 'InputField',
                    sx: { gap: '15px' },
                },
            ],
        },
    ],
};
export const aimDialogConfig = {
    title: 'NEW SHIPMENT - AIR IMPORT',
    formState: 'aimNewShipmentForm',
    resetAction: 'resetFormDataAim',
    setFormDataAction: 'setFormDataAim',
    tableName: 'il_air_import',
    sendReducerNames: ['addAimForm', 'addAimHBL', 'addAimContainer', 'addAimRate'],
    keyName: [
        'il_air_import_hbl',
        'il_air_import_hbl_alias',
        'hawb',
        'il_trade_partner_id_shipper',
        'il_trade_partner_id_consignee',
    ],
    reducerActionsHBL: ['addHAWBAim', 'updateHAWBtitleAim', 'deleteHAWBAim', 'updateHAWBAim'],
    reducerActionsCNTR: ['addAliasAim', 'updateAliasAim', 'deleteAliasAim'],
    type: 'air',
    sections: [
        {
            title: 'SHIPMENT INFO',
            usage: 'NewShipmentDialog',
            sx: { height: '400px' },
            size: 3,
            fields: [
                {
                    key: 'il_team_id',
                    label: 'Team',
                    type: 'AutocompleteFieldTeam',
                    sx: { gap: '15px' },
                },
                {
                    key: 'il_opus_reference_id',
                    label: 'Opus Ref',
                    type: 'InputField',
                    sx: { gap: '15px' },
                },
                {
                    key: 'il_trade_partner_id_client',
                    label: 'Client',
                    type: 'AutocompleteFieldTradePartner',
                    dataType: 'il_trade_partner',
                    sx: { gap: '15px' },
                },
                {
                    key: 'il_trade_partner_id_forwarder',
                    label: 'Forwarder',
                    type: 'AutocompleteFieldTradePartner',
                    dataType: 'il_trade_partner',
                    sx: { gap: '15px' },
                },
                { key: 'mawb', label: 'MAWB', type: 'InputField', sx: { gap: '15px' } },
                {
                    key: 'incoterm',
                    label: 'Incoterm',
                    type: 'AutocompleteField_Single',
                    options: 'incotermList',
                    sx: { gap: '15px' },
                },
            ],
        },
        {
            title: 'DATE/PLACE INFO',
            usage: 'NewShipmentDialog',
            sx: { height: '400px' },
            size: 3,
            fields: [
                {
                    key: 'etd',
                    label: 'ETD',
                    type: 'DateField',
                },
                {
                    key: 'eta',
                    label: 'ETA',
                    type: 'DateField',
                },
                {
                    key: 'feta',
                    label: 'F.ETA',
                    type: 'DateField',
                },
                {
                    key: 'il_location_id_aol',
                    label: 'AOL',
                    type: 'AutocompleteField_CodeName',
                    dataType: 'il_location',
                    displayKey: 'code',
                },
                {
                    key: 'il_location_id_aod',
                    label: 'AOD',
                    type: 'AutocompleteField_CodeName',
                    dataType: 'il_location',
                    displayKey: 'code',
                },
                {
                    key: 'il_location_id_faod',
                    label: 'F.AOD',
                    type: 'AutocompleteField_CodeName',
                    dataType: 'il_location',
                    displayKey: 'code',
                },
            ],
        },
        {
            title: 'HAWB',
            usage: 'NewShipmentCNTR',
            sx: { height: '400px', p: 1 },
            size: 6,
            fields: [{ key: 'hawb', type: 'NewShipmentHBL' }],
            sections: [
                {
                    key: 'il_trade_partner_id_shipper',
                    label: 'Shipper',
                    type: 'AutocompleteFieldTradePartner',
                    dataType: 'il_trade_partner',
                },
                {
                    key: 'il_trade_partner_id_consignee',
                    label: 'Consignee',
                    type: 'AutocompleteFieldTradePartner',
                    dataType: 'il_trade_partner',
                },
                {
                    key: 'reference',
                    label: 'Reference',
                    type: 'InputField',
                    sx: { gap: '15px' },
                },
            ],
        },
    ],
};
export const aexDialogConfig = {
    title: 'NEW SHIPMENT - AIR EXPORT',
    formState: 'aexNewShipmentForm',
    resetAction: 'resetFormDataAex',
    setFormDataAction: 'setFormDataAex',
    tableName: 'il_air_export',
    sendReducerNames: ['addAexForm', 'addAexHBL', 'addAexContainer', 'addAexRate'],
    keyName: [
        'il_air_export_hbl',
        'il_air_export_hbl_alias',
        'hawb',
        'il_trade_partner_id_shipper',
        'il_trade_partner_id_consignee',
    ],
    reducerActionsHBL: ['addHAWBAex', 'updateHAWBtitleAex', 'deleteHAWBAex', 'updateHAWBAex'],
    reducerActionsCNTR: ['addAliasAex', 'updateAliasAex', 'deleteAliasAex'],
    type: 'air',
    sections: [
        {
            title: 'SHIPMENT INFO',
            usage: 'NewShipmentDialog',
            sx: { height: '400px' },
            size: 3,
            fields: [
                {
                    key: 'il_team_id',
                    label: 'Team',
                    type: 'AutocompleteFieldTeam',
                    sx: { gap: '15px' },
                },
                {
                    key: 'il_opus_reference_id',
                    label: 'Opus Ref',
                    type: 'InputField',
                    sx: { gap: '15px' },
                },
                {
                    key: 'il_trade_partner_id_client',
                    label: 'Client',
                    type: 'AutocompleteFieldTradePartner',
                    dataType: 'il_trade_partner',
                    sx: { gap: '15px' },
                },
                {
                    key: 'il_trade_partner_id_forwarder',
                    label: 'Forwarder',
                    type: 'AutocompleteFieldTradePartner',
                    dataType: 'il_trade_partner',
                    sx: { gap: '15px' },
                },
                {
                    key: 'booking_number',
                    label: 'Booking',
                    type: 'InputField',
                    sx: { gap: '15px' },
                },
                { key: 'mawb', label: 'MAWB', type: 'InputField', sx: { gap: '15px' } },
                {
                    key: 'incoterm',
                    label: 'Incoterm',
                    type: 'AutocompleteField_Single',
                    options: 'incotermList',
                    sx: { gap: '15px' },
                },
            ],
        },
        {
            title: 'DATE/PLACE INFO',
            usage: 'NewShipmentDialog',
            sx: { height: '400px' },
            size: 3,
            fields: [
                {
                    key: 'etd',
                    label: 'ETD',
                    type: 'DateField',
                },
                {
                    key: 'eta',
                    label: 'ETA',
                    type: 'DateField',
                },
                {
                    key: 'feta',
                    label: 'F.ETA',
                    type: 'DateField',
                },
                {
                    key: 'il_location_id_aol',
                    label: 'AOL',
                    type: 'AutocompleteField_CodeName',
                    dataType: 'il_location',
                    displayKey: 'code',
                },
                {
                    key: 'il_location_id_aod',
                    label: 'AOD',
                    type: 'AutocompleteField_CodeName',
                    dataType: 'il_location',
                    displayKey: 'code',
                },
                {
                    key: 'il_location_id_faod',
                    label: 'F.AOD',
                    type: 'AutocompleteField_CodeName',
                    dataType: 'il_location',
                    displayKey: 'code',
                },
            ],
        },
        {
            title: 'HAWB',
            usage: 'NewShipmentCNTR',
            sx: { height: '400px', p: 1 },
            size: 6,
            fields: [{ key: 'hawb', type: 'NewShipmentHBL' }],
            sections: [
                {
                    key: 'il_trade_partner_id_shipper',
                    label: 'Shipper',
                    type: 'AutocompleteFieldTradePartner',
                    dataType: 'il_trade_partner',
                },
                {
                    key: 'il_trade_partner_id_consignee',
                    label: 'Consignee',
                    type: 'AutocompleteFieldTradePartner',
                    dataType: 'il_trade_partner',
                },
                {
                    key: 'reference',
                    label: 'Reference',
                    type: 'InputField',
                    sx: { gap: '15px' },
                },
            ],
        },
    ],
};
export const truckingDialogConfig = {
    title: 'NEW SHIPMENT - FTL/LTL',
    formState: 'truckingNewShipmentForm',
    resetAction: 'resetFormDataTrucking',
    setFormDataAction: 'setFormDataTrucking',
    tableName: 'il_ftl_ltl',
    sendReducerNames: ['addTruckingForm', 'addTruckingBOL', 'addTruckingRate'],
    reducerActionsCNTR: ['addAliasTrucking', 'updateAliasTrucking', 'deleteAliasTrucking'],
    type: 'trucking',
    sections: [
        {
            title: 'SHIPMENT INFO',
            usage: 'NewShipmentDialog',
            sx: { height: '400px' },
            size: 3,
            fields: [
                {
                    key: 'il_team_id',
                    label: 'Team',
                    type: 'AutocompleteFieldTeam',
                    sx: { gap: '15px' },
                },
                {
                    key: 'il_opus_reference_id',
                    label: 'Opus Ref',
                    type: 'InputField',
                    sx: { gap: '15px' },
                },
                {
                    key: 'il_trade_partner_id_client',
                    label: 'Client',
                    type: 'AutocompleteFieldTradePartner',
                    dataType: 'il_trade_partner',
                    sx: { gap: '15px' },
                },
                {
                    key: 'il_trade_partner_id_shipper',
                    label: 'Shipper',
                    type: 'AutocompleteFieldTradePartner',
                    dataType: 'il_trade_partner',
                    sx: { gap: '15px' },
                },
                {
                    key: 'il_trade_partner_id_consignee',
                    label: 'Consignee',
                    type: 'AutocompleteFieldTradePartner',
                    dataType: 'il_trade_partner',
                    sx: { gap: '15px' },
                },
                {
                    key: 'bol',
                    label: 'BOL',
                    type: 'InputField',
                    sx: { gap: '15px' },
                },
                {
                    key: 'shipment_type',
                    label: 'Type',
                    type: 'AutocompleteField_Single',
                    options: 'trucking_type',
                    sx: { gap: '15px' },
                },
            ],
        },

        {
            title: 'DATE/PLACE INFO',
            usage: 'NewShipmentDialog',
            sx: { height: '400px' },
            size: 3,
            fields: [
                {
                    key: 'etd',
                    label: 'ETD',
                    type: 'DateField',
                },
                {
                    key: 'eta',
                    label: 'ETA',
                    type: 'DateField',
                },
                {
                    key: 'feta',
                    label: 'F.ETA',
                    type: 'DateField',
                },
            ],
        },
        {
            title: 'ALIAS',
            usage: 'NewShipmentTrucking',
            sx: { height: '400px' },
            size: 6,
            fields: [{ key: 'alias', type: 'TruckingNewShipmentAlias' }],
        },
    ],
};
